import { inject, injectable } from 'inversify';
import type { PlanningAlgorithm } from '@/engine/PlanningAlgorithm/PlanningAlgorithm';
import * as DT from '@/engine/PlanningAlgorithm/DataTypes';

import { TYPES } from '@/engine/ioc';

@injectable()
export class WorkflowIndicationsResolver {
  private readonly _planningAlgorithm: PlanningAlgorithm;

  public constructor(@inject(TYPES.PlanningAlgorithm) planningAlgorithm: PlanningAlgorithm) {
    this._planningAlgorithm = planningAlgorithm;
  }

  public async resolveWorkflowIndication(descriptor: string, isOptional?: boolean): Promise<boolean> {
    const value = await this._planningAlgorithm.getIValueAsync(descriptor);

    if (!value) {
      return false;
    }

    if (value.type.name == DT.Polyline.Type.name) {
      return this._resolvePolylineIndication(value as DT.Polyline, isOptional);
    }

    return true;
  }

  private _resolvePolylineIndication(polyline: DT.Polyline, isOptional?: boolean): boolean {
    return polyline.value.points.length > 0 || isOptional !== true;
  }
}
